PJQ.views.bidForms.Proposals = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposals'),
        subTemplates: {
            proposalLeveling: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Leveling'),
            item: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Item'),
            itemTooltip: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Item-Tooltip')
        },
        canEdit: false,
        canSelect: false,
        isLeveling: false
    },
    events: {
        "click .open-bidders-tab": "openBiddersTab",
        'click .proposals-compare': 'compareProposals',
        "click .proposals-export-excel": "exportExcel",
        "click .proposals-export-selected": "exportSelected",
        "click .proposals-export-select": "selectProposals",
        "click .proposals-cancel-select": "cancelSelect",
        "click .cb-alternate-enabled": "alternateEnabled",
        "click .btn-view-proposal": "viewProposal",
        "click .btn-reject-proposal": "rejectProposal",
        "click .btn-revise-proposal": "reviseProposal",
        "click .btn-award-proposal": "awardProposal",
        "click .btn-export-proposal": "exportProposal",
        "click .btn-delete-proposal": "deleteProposal",
        'keyup .proposals-search': 'filterProposals',
        'click .proposals-clear-filters': 'clearFilters',
        'click .btn-enable-leveling': 'enableLeveling',
        'click .btn-cancel-leveling': 'cancelLeveling',
        'click .btn-save-leveling': 'saveLeveling',
        'mousedown .proposal-item': 'levelItem'
    },
    beforeFirstRender: function () {
        $('body').on('mousedown', _.bind(function () {
            if (this.options.isLeveling) {
                this.removeActiveLevelItem();
            }
        }, this));

        this.search = "";
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
        this.listenTo(this.collection, "sync change update reset", this.render);
    },
    renderData: function () {
        let proposals = []
        if (this.options.bidForm && this.options.bidForm.get('bidPackage') != null) {
            proposals = this.collection.getProposals(null);
        } else {
            proposals = this.collection.getProposals(this.options.bidForm.id);
        }
        _.each(proposals.models, function (proposal) {
            if (proposal.get('viewedOn') == null && proposal.get('submittedOn') != null) {
                proposal.updateViewed();
            }
        });

        return {
            canEdit: this.options.canEdit,
            canView: !this.options.settings.get('isSealBids') || this.options.settings.isSealedBidContact(PJQ.app.session.user.get('id')),
            collection: proposals,
            canSelect: this.options.canSelect,
            search: this.search,
            settings: this.options.settings
        };
    },
    afterRender: function () {
        this.statusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.proposals-status-filter'),
            onChange: _.bind(this.filterProposals, this),
            isMultiple: true,
            defaultValue: this.statusFilter,
            noneSelectedText: 'No Filters'
        });
        this.searchBar = this.$('.proposals-search');

        this.renderProposals();

        this.$('.proposals-container').sortable({
            items: '.bid-form-proposal',
            connectWith: '.bid-form-proposal',
            update: _.bind(function () {
                this.changeSort();
            }, this)
        });
    },
    changeSort: function () {
        let self = this,
            proposals = this.collection.getProposals(this.options.bidForm.id);
        this.$('.bid-form-proposal').each(function (index) {
            if (self.getSearchFilter().length === 0 && self.getStatusFilter().length === 0) {
                let proposal = proposals.get($(this).data('cid'));
                if (proposal) {
                    proposal.set('sortOrder', index + 1);
                    proposal.save();
                }
            }
        });
    },
    clearFilters: function () {
        this.statusFilterPicker.deselectAll();
        this.search = "";
        this.searchBar.val(this.search);
        this.filterProposals();
    },
    filterProposals: function () {
        this.statusFilter = this.statusFilterPicker.getValue();
        this.search = this.searchBar.val().trim();
        this.renderProposals();
    },
    selectProposals: function () {
        this.selectedIds = [];
        this.options.canSelect = true;
        this.exportToolbar = new PJQ.views.toolbars.ExportSelectedToolbar({
            el: this.$el,
            onExport: _.bind(function () {
                this.exportSelected();
                this.exportToolbar.destroy();
                this.cancelSelectProposals();
            }, this),
            onClose: _.bind(function () {
                this.cancelSelectProposals();
            }, this)
        });
        this.render();
    },
    cancelSelectProposals: function () {
        this.options.canSelect = false;
        this.render();
    },
    getFilteredProposals: function () {
        let proposals = [];
        if (this.options.bidForm && this.options.bidForm.get('bidPackage') != null) {
            proposals = this.collection.getProposals(null).models;
        } else {
            proposals = this.collection.getProposals(this.options.bidForm.id).models;
        }

        if (this.options.settings.get('isBidLevelingEnabled')) {
            /* 2024-09-18 Blue: are not filtering unsubmitted out of levelling mode at this time.
            proposals = _.filter(proposals, function (proposal) {
                return proposal.get('isSubmitted');
            });
            */
        }

        if (true) {
            let searchFilter = this.getSearchFilter().toLowerCase();
            if (searchFilter.length > 0) {
                proposals = _.filter(proposals, function (model) {
                    return null != _.find(model.bidder.contacts.models, function (contact) {
                        if (contact.get('email').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else if (contact.get('companyName').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else if (contact.get('contactName').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else {
                            let numSearch = PJQ.helpers.formatHelpers.numbersOnly(searchFilter);
                            if (_.size(numSearch) === 0)
                                return false;
                            if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('phone')).indexOf(numSearch) !== -1)
                                return true;
                            else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('fax')).indexOf(numSearch) !== -1)
                                return true;
                            else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('cell')).indexOf(numSearch) !== -1)
                                return true;
                        }
                    });
                });
            }

            let statusF = this.getStatusFilter();
            if (statusF.length > 0) {
                proposals = _.filter(proposals, function (model) {
                    let result = false;
                    if (statusF.indexOf('submitted') !== -1 && model.get('isSubmitted')) {
                        result = true;
                    } else if (statusF.indexOf('notsubmitted') !== -1 && !model.get('isSubmitted') && !model.get('isRejected')) {
                        result = true;
                    } else if (statusF.indexOf('rejected') !== -1 && model.get('isRejected')) {
                        result = true;
                    }

                    if (statusF.indexOf('locked') !== -1 && model.get('isLocked')) {
                        result = true;
                    } else if (statusF.indexOf('locked') !== -1 && !model.get('isLocked')) {
                        result = false;
                    }

                    if (statusF.indexOf('unlocked') !== -1 && !model.get('isLocked')) {
                        result = true;
                    } else if (statusF.indexOf('unlocked') !== -1 && model.get('isLocked')) {
                        result = false;
                    }

                    return result;
                }, this);
            }
        }

        return new PJQ.collections.bidForms.Proposals(proposals)
    },
    makeProposalItemTooltip: function ($item) {
        if ($item.hasClass('leveled')) {
            new PJQ.Tooltip($item, {
                template: this.options.subTemplates.itemTooltip,
                container: this.$el,
                trigger: 'hover',
                renderData: _.bind(function () {
                    return {
                        cost: parseInt($item.data('cost')),
                        leveledCost: parseInt($item.data('leveledCost')),
                        multiplier: parseInt($item.data('multiplier')),
                        leveledMultiplier: parseInt($item.data('leveledMultiplier')),
                        notes: $item.data('notes')
                    };
                }, this)
            });
        }
    },
    makeProposalItem: function (proposalItem) {
        let itemClass,
            isAlternate = false;
        if (proposalItem instanceof PJQ.models.bidForms.Alternate) {
            itemClass = 'proposal-alternate';
            isAlternate = true;
        } else if (proposalItem instanceof PJQ.models.bidForms.LineItem) {
            itemClass = 'proposal-line-item';
        } else {
            return $('<div></div>');
        }

        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.item, {
            isQuestion: PJQ.helpers.bidForms.lineItemQuestionTypes.indexOf(proposalItem.get('type')) !== -1,
            itemClass: itemClass,
            isAlternate: isAlternate,
            proposalItem: proposalItem
        });
    },
    enableLeveling: function () {
        this.options.isLeveling = true;
        this.renderProposals();
    },
    cancelLeveling: function () {
        this.options.isLeveling = false;
        this.renderProposals();
    },
    saveLeveling: function () {
        this.options.isLeveling = false;

        _.each(this.leveledProposals, function (prop) {

        });

        this.renderProposals();
    },
    saveActiveLevelItem: function () {
        let $active = this.$('.level-proposal-item');
        if ($active.length > 0) {
            let leveledCost = parseInt(PJQ.helpers.formatHelpers.numbersOnly($active.find('.item-cost').val())),
                $multiplier = $active.find('.item-multiplier'),
                leveledMultiplier = null;
            if ($multiplier.length > 0) {
                leveledMultiplier = parseInt(PJQ.helpers.formatHelpers.numbersOnly($active.find('.item-cost').val()));
            }

            if (this.contextLevelItem.get('cost') === leveledCost && (leveledMultiplier == null || this.contextLevelItem.get('multiplier') === leveledMultiplier)) {
                leveledMultiplier = null;
                leveledCost = null;
            }

            this.contextLevelItem.set({
                leveledCost: leveledCost,
                leveledMultiplier: leveledMultiplier
            });

            let notes = $active.find('.item-notes').val();
            this.contextLevelItem.set('notes', _.size(notes.trim()) > 0 ? notes : '');

            if (this.contextLevelItem.hasChanged() && null == _.findWhere(this.leveledProposals, function (prop) {
                return prop.id === this.contextProposal.id;
            }, this)) {
                this.leveledProposals.push(this.leveledProposals);
            }

            let $item = $active.closest('.proposal-item'),
                $proposal = $item.closest('.proposal-card'),
                proposalId = $proposal.data('proposalId'),
                proposal = this.proposals.get(proposalId);
            $proposal.find('.proposal-sub-total').text(PJQ.helpers.formatHelpers.formatCurrency(proposal.calculateTotal()));
            $proposal.find('.proposal-leveled-total').text(PJQ.helpers.formatHelpers.formatCurrency(proposal.calculateTotal(true)));

            let $newItem = this.makeProposalItem(this.contextLevelItem);
            $item.replaceWith($newItem);
            $item.find('.item-cost-d').text(PJQ.helpers.formatHelpers.formatCurrency(leveledCost));

            this.makeProposalItemTooltip($newItem.find('.proposal-item'));
        }
    },
    removeActiveLevelItem: function () {
        this.saveActiveLevelItem();
        this.$('.level-proposal-item').remove();
        this.contextProposal = null;
        this.contextLevelItem = null;
    },
    levelItem: function (e) {
        e.stopPropagation();

        if (!this.options.isLeveling) {
            return;
        }

        let $target = $(e.currentTarget),
            itemCid = $target.data('cid');
        if (this.contextLevelItem == null || itemCid !== this.contextLevelItem.cid) {
            this.removeActiveLevelItem();

            let proposalId = $target.closest('.proposal-card').data('proposalId');
            this.contextProposal = this.proposals.get(proposalId);
            if ($target.hasClass('proposal-line-item')) {
                this.contextLevelItem = this.contextProposal.lineItems.get(itemCid);
            } else if ($target.hasClass('proposal-alternate')) {
                this.contextLevelItem = this.contextProposal.alternates.get(itemCid);
            } else {
                return;
            }

            let $out = $('<div class="level-proposal-item top-0 left-0 right-0 ht-100p position-absolute elevation-1 rounded bg-white"></div>');
            if (this.contextLevelItem.get('type').toLowerCase() === "sum") {
                let cost = this.contextLevelItem.get('leveledCost') ? this.contextLevelItem.get('leveledCost') : this.contextLevelItem.get('cost');
                $out.append('<div class="text-align-right mr-4 wd-100 border-bottom border-muted pb-2"><input type="text" class="input-text mt-2 item-cost text-align-right" value="' + PJQ.helpers.formatHelpers.formatCurrency(cost, 2, false) + '" /></div>');

                let $cost = $out.find('.item-cost');
                PJQ.helpers.inputHelpers.inputMaskCurrency($cost, 2);
                $cost.focus();
            } else {

            }
            $out.append('<textarea class="item-notes p-1 wd-100" placeholder="Notes...">' + (this.contextLevelItem.get('notes') ? this.contextLevelItem.get('notes') : '') + '</textarea>');
            $target.append($out);
        }
    },
    alternateEnabled: function (e) {
        let $target = $(e.currentTarget),
            alternateId = $target.data('alternateId'),
            isEnabled = $target.prop('checked');
        _.each(this.proposals.models, function (proposal) {
            let propAlternate = proposal.alternates.findWhere({bidFormAlternateId: alternateId});
            if (propAlternate != null) {
                propAlternate.set('isLevel', isEnabled);
            }
        });
        let bfAlternate = this.options.bidForm.alternates.get(alternateId);
        bfAlternate.set('isLevel', isEnabled);
        this.renderProposals();
    },
    viewProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.preview(this.collection, {
            isEdit: false
        });
    },
    rejectProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        new PJQ.views.bidForms.RejectModal({
            onConfirm: _.bind(function (note) {
                selectedProp.reject(note);
                this.render();
            }, this)
        });
    },
    reviseProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.preview(this.collection, {
            isEdit: true
        });
    },
    awardProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        _.each(this.collection.models, function (proposal) {
            proposal.set({
                awardedOn: null,
                awardedBy: null,
                isAwarded: false
            });
        });
        selectedProp.award(true);
    },
    exportProposal: function (e) {
        /*
        Export already being handled by PJQ.views.bidForms.Proposal - if this is needed, then need to deconflict.

        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.export();
         */
    },
    deleteProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this proposal?  This will delete all versions of the proposal.",
            onDelete: _.bind(function () {
                selectedProp.destroy();
                this.collection.trigger('change');
            }, this)
        });
    },
    renderProposals: function () {
        this.leveledProposals = [];
        this.contextProposal = null;
        this.contextLevelItem = null;

        this.proposals = this.getFilteredProposals();
        if (this.options.settings.get('isBidLevelingEnabled')) {
            this.renderSubTemplate(false, this.options.subTemplates.proposalLeveling, this.$('.proposals-inner'), {
                makeProposalItem: _.bind(this.makeProposalItem, this),
                proposals: this.proposals,
                bidForm: this.options.bidForm,
                settings: this.options.settings,
                isLeveling: this.options.isLeveling
            });
        } else {
            this.$('.proposals-inner').empty();

            let $row = $('<div class="row"></div>');
            this.$('.proposals-inner').append($row);
            _.each(_.sortBy(this.proposals.models, function (model) {
                return model.get('sortOrder');
            }), function (model) {
                //don't render unsubmitted proposals to select from
                if (this.options.canSelect && !model.get('isSubmitted')) {
                    return;
                }

                let container = $('<div class="col-4 bid-form-proposal" data-cid="' + model.cid + '" />');
                $row.append(container);
                new PJQ.views.bidForms.Proposal({
                    model: model,
                    project: this.options.project,
                    collection: this.collection,
                    el: container,
                    settings: this.options.settings,
                    canSelect: this.options.canSelect,
                    isSelected: this.selectedIds != null && this.selectedIds.indexOf(model.id) !== -1,
                    onSelect: _.bind(function (isSelected) {
                        if (isSelected) {
                            this.selectedIds = _.union([model.id], this.selectedIds);
                        } else {
                            this.selectedIds = _.without(this.selectedIds, model.id);
                        }
                        this.exportToolbar.updateSelectedCount(_.size(this.selectedIds));
                    }, this)
                });
            }, this);
        }

        if (PJQ.app.options.initProposal != null && !PJQ.app.options.initProposal.get('isShown')) {
            let matchInitProposal = this.collection.getProposals().get(PJQ.app.options.initProposal.id);
            if (matchInitProposal == null) {
                // unable to find initProposal by id, check revisions
                matchInitProposal = _.find(this.collection.getProposals().models, function (prop) {
                    return _.size(prop.get('revisions')) > 0
                        && null != _.find(prop.get('revisions'), function (rev) {
                            return rev.proposalId === PJQ.app.options.initProposal.id;
                        });
                });
            }

            if (matchInitProposal != null) {
                matchInitProposal.preview(this.collection, {
                    isEdit: false
                });
                PJQ.app.options.initProposal = null;
            }
        }

        let self = this;
        this.$('.proposal-item.leveled').each(function () {
            self.makeProposalItemTooltip($(this));
        });
    },
    getStatusFilter: function () {
        return this.statusFilter ? this.statusFilter : [];
    },
    getSearchFilter: function () {
        return this.search ? this.search : "";
    },
    openBiddersTab: function () {
        $('a[href="#biddersContainer"]').tab('show');
    },
    compareProposals: function () {
        new PJQ.views.bidForms.ProposalsCompareModal({
            collection: this.collection.getProposals(this.options.bidForm.id),
            settings: this.options.settings
        });
    },
    exportSelected: function () {
        this.exportProposals(this.selectedIds);
        /*
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'bidforms',
                value: this.options.bidForm.id
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: "ids",
                value: this.selectedIds
            }
        ]));
         */
    },
    exportExcel: function () {
        this.exportProposals(null);
        /*
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'bidforms',
                value: this.options.bidForm.id
            },
            {
                endpoint: 'export'
            }
        ]));
         */
    },
    exportProposals: function(proposalIds) {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false,
            fnExport = _.bind(function(proposalIds, exportLeveledProposal, exportComments) {
                PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'bidforms',
                        value: this.options.bidForm.id
                    },
                    {
                        endpoint: 'export'
                    }
                ], [
                    {
                        parameter: 'leveling',
                        value: exportLeveledProposal
                    },
                    {
                        parameter: 'comments',
                        value: exportComments
                    },
                    {
                        parameter: "ids",
                        value: proposalIds
                    }
                ]));
        }, this);

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: _.bind(function(exportLeveledProposal, exportComments) {
                    fnExport(proposalIds, exportLeveledProposal, exportComments);
                }, this)
            });
        }
        else {
            fnExport(proposalIds, false, false);
        }

    }
});

PJQ.views.bidForms.Proposal = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal'),
        subTemplates: {
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input')
        },
        canSelect: false,
        onSelect: null,
        isSelected: false
    },
    events: {
        "click .proposal-review-button": "reviewProposal",
        "click .proposal-edit-button": "editProposal",
        "click .btn-export-proposal": "exportProposal",
        "change .cb-proposal": "selectProposal",
        "click .btn-line-item-comments": "viewComments",
        "click .btn-alternate-comments": "viewComments"
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
        this.model.on("sync", this.render, this);
    },
    renderData: function () {
        let isLowestProposal = false,
            isLowestProposalWithAlternates = false,
            lowestProposal = this.collection.getLowestProposal(this.model.get('bidFormId'), false),
            lowestProposalWithAlternates = this.collection.getLowestProposal(this.model.get('bidFormId'), true);

        if (lowestProposal && lowestProposal.id === this.model.id)
            isLowestProposal = true;
        if (lowestProposalWithAlternates && lowestProposalWithAlternates.id === this.model.id)
            isLowestProposalWithAlternates = true;
        return {
            proposal: this.model,
            canEdit: this.options.canEdit,
            isLowestProposal: isLowestProposal,
            isLowestProposalWithAlts: isLowestProposalWithAlternates,
            helpers: PJQ.helpers,
            settings: this.options.settings,
            canSelect: this.options.canSelect,
            isSelected: this.options.isSelected,
            getItemInput: _.bind(this.getItemInput, this),
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            canAddComments: PJQ.app.session.project.hasPermission('bidForms.canAddComments')
        };
    },
    afterRender: function () {
        this.$('.proposals-container').sortable({
            items: '.bid-form-proposal',
            connectWith: '.bid-form-proposal'
        });

    },
    reviewProposal: function () {
        this.model.preview(this.collection, {
            isEdit: false
        });
    },
    editProposal: function () {
        this.model.preview(this.collection, {
            isEdit: true
        });
    },
    exportProposal: function () {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: _.bind(function(exportLeveledProposal, exportComments) {
                    this.model.export(exportLeveledProposal, exportComments);
                }, this)
            });
        }
        else {
            this.model.export(false, false);
        }
    },
    selectProposal: function () {
        if (typeof this.options.onSelect === 'function') {
            this.options.onSelect(this.$('.cb-proposal').prop('checked'));
        }
    },
    getItemInput: function (model) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: false,
            helpers: PJQ.helpers
        });
    },
    viewComments: function(event) {
        let el = $(event.currentTarget).parent(),
            cid = $(event.currentTarget).data('cid'),
            isLineItem = $(event.currentTarget).hasClass('btn-line-item-comments'),
            item = isLineItem ? this.model.lineItems.get(cid) : this.model.alternates.get(cid);

        new PJQ.views.bidForms.ProposalItemEditModal({
            item: item,
            onSave: _.bind(function() {
                var comments = _.filter(item.comments.models, function (comment) {
                        return !comment.get('isDeleted');
                    }),
                    $commentButton = el.find('.btn-line-item-comments'),
                    $commentButtonIcon = el.find('.btn-line-item-comments i'),
                    tooltip = 'No';

                if (comments.length > 0) {
                    tooltip = comments.length.toString();

                    $commentButton.removeClass('btn-transparent-dark').addClass('btn-light');
                    $commentButtonIcon.removeClass('text-muted').addClass('text-dark');
                }
                else {
                    $commentButton.removeClass('btn-light').addClass('btn-transparent-dark');
                    $commentButtonIcon.removeClass('text-dark').addClass('text-muted');
                }

                tooltip = tooltip + ' Comment' + (comments.length!=1 ? 's':'');
                $commentButton.attr('title', tooltip);

                // if we're not in edit mode, we have to manually save changes to the comments.
                if (!this.options.isEdit && _.some(item.comments.models, function(model) {
                    return (!model.get('proposalLineItemCommentId') && isLineItem) || (!model.get('proposalAlternateCommentId') && !isLineItem)  || model.get('isDeleted');
                })) {
                    item.comments.save({
                        success: _.bind(function (data) {
                            item.comments.reset(data);
                            PJQ.notifications.notify.successNotify({
                                message: 'Comments updated successfully'
                            });
                        }, this),
                        error: _.bind(function () {
                            PJQ.notifications.notify.errorNotify({
                                message: 'Comment update failed'
                            });
                        }, this)
                    });
                }
            }, this)
        });

    }
});

PJQ.views.bidForms.ProposalsCompareModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Proposals-Compare'),
        compareProposals: []
    },
    events: {
        "click .proposal-compare": "compareProposalClick"
    },
    renderData: function () {
        return {
            lowestProposal: this.collection.getLowestProposal(false),
            lowestProposalWithAlternates: this.collection.getLowestProposal(true),
            helpers: PJQ.helpers,
            collection: this.collection,
            settings: this.options.settings,
            compareProposals: this.getCompareProposals()
        };
    },
    afterRender: function () {
        new PJQ.views.bidForms.ProposalsCompare({
            el: this.$('.proposals-compare'),
            collection: this.getCompareProposals(),
            settings: this.options.settings
        });
    },
    getCompareProposals: function () {
        return new PJQ.collections.bidForms.Proposals(this.options.compareProposals);
    },
    compareProposalClick: function (e) {
        let cid = $(e.currentTarget).closest('.proposal-select').data('cid');
        this.compareProposal(this.collection.get({cid: cid}));
    },
    compareProposal: function (proposal) {
        if (_.findWhere(this.options.compareProposals, {cid: proposal.cid})) {
            this.options.compareProposals = _.filter(this.options.compareProposals, function (compareProposal) {
                return proposal.cid !== compareProposal.cid;
            })
        } else {
            this.options.compareProposals.push(proposal);
        }
        this.render();
    }
});

PJQ.views.bidForms.ProposalsCompare = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposals-Compare'),
        subTemplates: {
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input')
        }
    },
    events: {
        "click .proposal-edit-button": "editProposal"
    },
    renderData: function () {
        return {
            lowestProposal: this.collection.getLowestProposal(false),
            lowestProposalWithAlternates: this.collection.getLowestProposal(true),
            getItemInput: _.bind(this.getItemInput, this),
            helpers: PJQ.helpers,
            collection: this.collection,
            settings: this.options.settings
        };
    },
    reviewProposal: function () {
        this.model.preview(this.collection, {
            isEdit: false
        });
    },
    getItemInput: function (model) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: false,
            helpers: PJQ.helpers
        });
    }
});

PJQ.views.bidForms.RejectModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'modal-reject-proposal'),
        onConfirm: null
    },
    events: {
        'click .btn-confirm': 'confirm'
    },
    confirm: function () {
        let rejectNote = this.$(".reject-note").val();
        if (typeof this.options.onConfirm === 'function') {
            this.options.onConfirm(rejectNote);
        }
        this.removeModal();
    }
});

PJQ.views.bidForms.ExportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'modal-export-proposals'),
        isBidLevelingEnabled: false,
        canViewComments: false,
        onExport: null
    },
    events: {
        'click .btn-export': 'exportProposals'
    },
    beforeModalCreated: function () {
        this.exportLeveledProposal = false;
        this.exportComments = false;

    },
    beforeRender: function () {
        this.renderData = {
            isBidLevelingEnabled: this.options.isBidLevelingEnabled,
            canViewComments: this.options.canViewComments
        };
    },
    exportProposals: function () {
        this.exportComments = this.$('.input-export-comments').prop('checked');
        if (typeof this.options.onExport === 'function') {
            this.options.onExport(this.exportLeveledProposal, this.exportComments);
        }
        this.removeModal();
    }
});

